// extracted by mini-css-extract-plugin
export var WpTagsContainer = "index-module--WpTagsContainer--SmgdN";